import { render } from "./cancelBooking.vue?vue&type=template&id=4abb709c&scoped=true&ts=true"
import script from "./cancelBooking.vue?vue&type=script&lang=ts"
export * from "./cancelBooking.vue?vue&type=script&lang=ts"

import "./cancelBooking.vue?vue&type=style&index=0&id=4abb709c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4abb709c"]])

export default __exports__